import React from "react";
import {
  Card,
  CardActionArea,
  Grid,
  Hidden,
  Icon,
  Typography,
} from "@material-ui/core";
import { useStyles } from "./CompanionOptionStyles";

type CompanionOptionProps = {
  title: string;
  iconUrl: any;
  autoFocus?: boolean;
  action: () => void;
  id: number;
  tabIndex?: number;
};

const CompanionOption = ({
  title,
  iconUrl,
  action,
  id,
  tabIndex,
  autoFocus,
}: CompanionOptionProps) => {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardActionArea
        onClick={() => action()}
        className={classes.action}
        tabIndex={tabIndex}
        autoFocus={autoFocus}
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Icon>
              <Hidden smDown>
                <img src={iconUrl} alt={title} className={classes.icon} />
              </Hidden>
              <Hidden mdUp>
                <img src={iconUrl} alt={title} className={classes.iconSm} />
              </Hidden>
            </Icon>
          </Grid>
          <Grid item>
            <Typography className={classes.title} gutterBottom>
              {title}
            </Typography>
          </Grid>
        </Grid>
      </CardActionArea>
    </Card>
  );
};

export default CompanionOption;
